export const CURRENCY_MAP_NAME = {
  COP: {
    symbol: 'COP',
    name: 'Peso Colombiano',
  },
  USD: {
    symbol: '$',
    name: 'Dólar Estadounidense',
  },
  PEN: {
    symbol: 'S/',
    name: 'Sol Peruano',
  },
  MXN: {
    symbol: '$',
    name: 'Peso Mexicano',
  },
  CLP: {
    symbol: 'CLP',
    name: 'Peso Chileno',
  },
  BOB: {
    symbol: 'BS.',
    name: 'Boliviano',
  },
  ARS: {
    symbol: '$',
    name: 'Peso Argentino',
  },
  PYG: {
    symbol: '₲',
    name: 'Guaraní Paraguayo',
  },
  UYU: {
    symbol: '$',
    name: 'Peso Uruguayo',
  },
  PAB: {
    symbol: 'B/',
    name: 'Balboa Panameño',
  },
  CRC: {
    symbol: '₡',
    name: 'Colón Costarricense',
  },
  GTQ: {
    symbol: 'Q',
    name: 'Quetzal Guatemalteco',
  },
  VES: {
    symbol: 'Bs',
    name: 'Bolívar Venezolano',
  },
  HNL: {
    symbol: 'L',
    name: 'Lempira Hondureño',
  },
  NIO: {
    symbol: 'C$',
    name: 'Córdoba Nicaragüense',
  },
  EUR: {
    symbol: '€',
    name: 'Euro',
  },
  DOP: {
    symbol: 'RD$',
    name: 'Peso Dominicano',
  },
};
